export default "__VITE_ASSET__DHNDbjRi__"